import { Col, Form, Input, Row, DatePicker, Divider } from 'antd';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import React, { useEffect } from 'react';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import dayjs from 'dayjs';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import moment from 'moment';
import { FormInstance } from 'rc-field-form';
import AdditionalDocument from './AdditionalDocument';

interface AdditionalInfoProps {
  editable: boolean;
  form: any;
  ExportData: any;
  export_id: string;
  additionalSubmittedDocs: any[];
  status: string | null;
  editableUser: any;
}

const AdditionalInfo: React.FC<AdditionalInfoProps> = ({
  editable,
  form,
  ExportData,
  export_id,
  additionalSubmittedDocs,
  status,
  editableUser,
}) => {
  useEffect(() => {
    if (ExportData) {
      console.log('Passed ExportData to AdditionalInfo:', ExportData);
      form.setFieldsValue({
        custom_deck_no: ExportData?.custom_deck_no || '',
        site_visit: ExportData?.site_visit || '',
      });
    }
  }, [form, ExportData]);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const currentUser = user?.name || 'Unknown User';

  const canEditFields = status !== 'DRAFT' && editableUser && editable;
  const fields: any = [
    {
      name: 'custom_deck_no',
      label: 'Cust Desk No',
      component: canEditFields ? (
        <Input
          value={form.getFieldValue('custom_deck_no')}
          onChange={(e) => form.setFieldsValue({ custom_deck_no: e.target.value })}
          placeholder="Enter Cust Desk No"
        />
      ) : (
        <BaseInput readOnly value={form.getFieldValue('custom_deck_no')} />
      ),
    },
    // {
    //   name: 'site_visit',
    //   label: 'Site Visit',
    //   component: canEditFields ? (
    //     <BaseSelect
    //       placeholder="Select Site Visit Status"
    //       options={[
    //         { value: 'PENDING', label: 'PENDING' },
    //         { value: 'COMPLETED', label: 'COMPLETED' },
    //         { value: 'SKIPPED', label: 'SKIPPED' },
    //       ]}
    //       onChange={(value) => form.setFieldsValue({ site_visit: value })}
    //     />
    //   ) : (
    //     <BaseInput readOnly value={form.getFieldValue('site_visit')} />
    //   ),
    // },
  ];

  return (
    <div>
      <br />
      <Row gutter={[16, 16]}>
        {fields.map(
          (field: {
            name: unknown;
            label:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | null
              | undefined;
            component:
              | string
              | number
              | boolean
              | React.ReactElement<any, string | React.JSXElementConstructor<any>>
              | Iterable<React.ReactNode>
              | React.ReactPortal
              | ((form: FormInstance<any>) => React.ReactNode)
              | null
              | undefined;
          }) => (
            <BaseCol xs={24} md={12} key={String(field.name)}>
              <Form.Item label={field.label} name={field.name}>
                {field.component}
              </Form.Item>
            </BaseCol>
          ),
        )}
      </Row>
      <br />
      <Divider />

      <h3 className="text-lg font-semibold mb-6">Additional Documents</h3>

      <AdditionalDocument
        export_id={export_id}
        editable={editable}
        additionalSubmittedDocs={additionalSubmittedDocs}
        status={status}
        editableUser={editableUser}
      />
    </div>
  );
};

export default AdditionalInfo;
